import * as React from 'react';

import search from '@images/search.svg';
import calendar from '@images/calendar.svg';
import database from '@images/database.svg';

import ImageLazy from '@common/react/components/UI/ImageLazy/ImageLazy';

const ForPatient: React.FC = ({}) => {
	return (
		<div className="cards-block__container home__container text-center patients-block">
			<div className="banner">
				<div className="gradient-header">
					<h2 className="cards-block__title">If you are a patient</h2>
				</div>
			</div>
			<div className="cards-block">
				<div className="home__card">
					<div className="home__card-icon__container icon-circle">
						<ImageLazy
							className="home__card__image"
							alt="search"
							src={search}
						/>
						<div className="circle"/>
					</div>
					<h3 className="home__card__text mt10">
						Find a Doctor
					</h3>
					<p>
						- verified providers<br/>
						- in-demand specialties<br/>
						- actual reviews and rates<br/>
						- simple and smart search<br/>
					</p>
				</div>
				<div className="home__card">
					<div className="home__card-icon__container icon-circle">
						<ImageLazy
							className="home__card__image"
							alt="calendar"
							src={calendar}
						/>
						<div className="circle"/>
					</div>
					<h3 className="home__card__text mt10">
						Schedule Appointment
					</h3>
					<p>
						- book appointment in three clicks<br/>
						- fill your data online<br/>
						- sign consents and answer questions<br/>
						- add appointment time notifies<br/>
					</p>
				</div>
				<div className="home__card">
					<div className="home__card-icon__container icon-circle">
						<ImageLazy
							className="home__card__image"
							alt="database"
							src={database}
						/>
						<div className="circle"/>
					</div>
					<h3 className="home__card__text mt10">
						After visiting
					</h3>
					<p>
						- get all information about your appointments
						<br/>
						- pay your bills online
						<br/>
						- manage your future appointments
						<br/>
						- sign up for promotions and discounts
					</p>
				</div>
			</div>
		</div>
	);
};

export default ForPatient;
